import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { HttpService } from "../../components/services/HttpService";
import { UserTypeConstants } from "../types/UserTypeConstants";
import { history } from '../../components/helpers/History';
import { UserActions } from "../actions/UserActions";
import { BackDropActions } from "../actions/BackDropActions";
import { AlertActions } from "../actions/AlertActions";
import { USER_ROLE } from '../../components/security/UserRole'

function* login(action) {
  try {
    var requestPayload = {
      username: action.payload.username,
      password: action.payload.password,
    };
    yield put(BackDropActions.start());
    const user = yield call(HttpService.post,"/login",requestPayload);
    if(user.status==="SUCCESS"){
      yield put(UserActions.loginSuccess(user.result));
    }else{
      yield put(UserActions.loginFailiure(user.result.description));
    }
  } catch (e) {
    yield put(UserActions.loginFailiure(e));
  }
}

function* verifyUser(action){
  try {
    var url ="/verifytoken?token="+localStorage.getItem("token");
    yield put(BackDropActions.start());
    const user = yield call(HttpService.post,url,{});
    if(user.status==="SUCCESS"){
      yield put(UserActions.loginSuccess(user.result));
    }else{
      history.push("/login");  
    }
  } catch (e) {
    history.push("/login");    
  }
}

function* loginSuccess(action) {
  try {
    var user = action.user.user;
    // if(user.userRole===USER_ROLE.PATIENT){
    //   const response = yield call(HttpService.get, "/patient/byuserid/" + user.id);
    //   if(response.status==="SUCCESS"){
    //     user.patientId = response.result.id;
    //   }else{
    //     yield put(UserActions.loginFailiure("Invalid user details."));
    //   }
    // }else if(user.userRole===USER_ROLE.DOCTOR){
    //   const response = yield call(HttpService.get, "/doctor/byuserid/" + user.id);
    //   if(response.status==="SUCCESS"){
    //     user.doctorId = response.result.id;
    //   }else{
    //     yield put(UserActions.loginFailiure("Invalid user details."));
    //   }
    // }
    yield put(BackDropActions.end());
    localStorage.setItem('token', action.user.token);
    localStorage.setItem('refreshToken', action.user.refreshToken);
    localStorage.setItem('user', JSON.stringify(user));
    yield put(AlertActions.success("Logged in successfully"));
    console.log(action.user);
    if(action.user.user.isAnsweredSecretQuestion==="Y"){
      var userRole = action.user.user && action.user.user.userRole ? action.user.user.userRole:''; 
      if(userRole===USER_ROLE.SYSTEM_ADMIN || userRole===USER_ROLE.HCP_ADMIN){
        history.push('/admin/home');
      }else if(userRole===USER_ROLE.DOCTOR){
        history.push('/doctor/home');
      }else {
        history.push('/home');
      }
    }else{
      history.push('/secretquestion');
    }
    
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}


function* loginFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message));
    localStorage.clear();
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* logout(action){
  try {
    yield put(AlertActions.success('User logout successfully.'));
    localStorage.clear();
    localStorage.removeItem('user');
    history.push('/login');
  } catch (e) {
  }
}

function* changePassword(action) {
  try {
    let requestPayload = {
      id: action.data.id,
      password: action.data.password,
      newPassword: action.data.newPassword,
      confirmPassword: action.data.confirmPassword,
    };
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post,"/users/change/password",requestPayload);
    if(response.status==="SUCCESS"){
      yield put(AlertActions.success('Password changed successfully.'));
    }else{
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(e));
  }
}

function* updatePassword(action) {
  try {
    let requestPayload = {
      id: action.data.id,
      newPassword: action.data.newPassword,
      confirmPassword: action.data.confirmPassword,
    };
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post,"/users/update/password",requestPayload);
    if(response.status==="SUCCESS"){
      yield put(AlertActions.success('Password updated successfully.'));
    }else{
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(e));
  }
}

function* validateEmail(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post,"/forget/verifyEmail?username="+action.email);
    if(response.status==="SUCCESS"){
      yield put(UserActions.validateEmailSuccess(response.result));
    }else{
      yield put(AlertActions.error(response.result.description));
    }
    yield put(BackDropActions.end());
  } catch (e) {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(e));
  }
}

function* snedOTP(action) {
  try {
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post,"/send/otp?username="+action.data.username);
    if(response && response.status && "SUCCESS" === response.status){
      yield put(UserActions.sendOTPSuccess());
      yield put(BackDropActions.end());
      yield put(AlertActions.success(response.result));
    }else{
      yield put(UserActions.sendOTPError());
      yield put(BackDropActions.end());
    }
  } catch (e) {
    yield put(BackDropActions.end());
    yield put(UserActions.sendOTPError());
    yield put(AlertActions.error(e));
  }
}



function* validateOTP(action) {
  try {
    var payload = {
      "username": action.data.username,
      "otp": action.data.otp
    }
    yield put(BackDropActions.start());
    const response = yield call(HttpService.post,"/validate/otp",payload);
    if(response && response.status && "SUCCESS" === response.status){
      yield put(BackDropActions.end());
      yield put(UserActions.validateOTPSuccess());
      yield put(AlertActions.success("One time password validated successfully."));
    }else{
      yield put(UserActions.validateOTPError());
      yield put(BackDropActions.end());
      yield put(AlertActions.error(response.result.description));
    }
  } catch (e) {
    yield put(UserActions.validateOTPError());
    yield put(BackDropActions.end());
    yield put(AlertActions.error(e));
  }
}

function* validateSecretQuestion(action) {
    try {
      var payload = {
        "username": action.data.username,
        "userSecretQuestionDto": action.data.userSecretQuestionDto
      }
  
      yield put(BackDropActions.start());
      const response = yield call(HttpService.post,"/validate/secretquestion",payload);
      if(response && response.status && "SUCCESS" === response.status){
        yield put(BackDropActions.end());
        yield put(UserActions.validateSecretQuestionSuccess());
        yield put(AlertActions.success('Secret question validate successfully.'));
      }else{
        yield put(BackDropActions.end());
        yield put(AlertActions.error(response.result.description));
      }
    } catch (e) {
      yield put(BackDropActions.end());
      yield put(AlertActions.error(e));
    }
  }
  


function* userAuth() {
  yield takeEvery(UserTypeConstants.LOGIN_REQUEST, login);
  yield takeEvery(UserTypeConstants.LOGIN_SUCCESS, loginSuccess);
  yield takeEvery(UserTypeConstants.LOGIN_FAILURE, loginFailiure);
  yield takeEvery(UserTypeConstants.LOGOUT, logout);
  yield takeEvery(UserTypeConstants.VERIFY_USER, verifyUser);
  yield takeEvery(UserTypeConstants.CHANGE_PASSWORD, changePassword);
  yield takeEvery(UserTypeConstants.UPDATE_PASSWORD, updatePassword);
  yield takeEvery(UserTypeConstants.VALIDATE_EMAIL, validateEmail);
  yield takeEvery(UserTypeConstants.VALIDATE_SECRET_QUESTION_REQUEST, validateSecretQuestion);
  yield takeEvery(UserTypeConstants.SEND_OTP_REQUEST, snedOTP);
  yield takeEvery(UserTypeConstants.VALIDATE_OTP_REQUEST, validateOTP);
  
  
  
}

export default userAuth;